"use client";

// src/components/RainbowKitProvider/chainIcons/optimism.svg
var optimism_default = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 28"><rect width="28" height="28" fill="%23FF0420" rx="14"/><path fill="%23fff" fill-rule="evenodd" d="M14 26.25v-5.185c5.333 0 9.658-4.324 9.658-9.657S19.333 1.75 14 1.75v5.185c-5.333 0-9.658 4.324-9.658 9.657S8.667 26.25 14 26.25Zm4.778-12.205v-.09c-2.106-1.049-3.684-2.627-4.733-4.733h-.09c-1.049 2.106-2.627 3.684-4.733 4.733v.09c2.106 1.049 3.684 2.627 4.733 4.733h.09c1.049-2.106 2.627-3.684 4.733-4.733Z" clip-rule="evenodd"/></svg>';
export {
  optimism_default as default
};
